import { useContext, useMemo } from 'react';
import { ChatCustomFilter, type CustomFilter } from '@trinity/chat';
import { ChatSessionFiltersContext } from '@trinity/chat-components/components/Chat/context';
import { useAgentResources } from '@trinity/chat-components/components/Chat.Header/AgentResources.Container.js';
import { FilterTypeEnum } from '../interfaces';

type AgentFilterValueWithMetadata = CustomFilter.ItemValue & {
  filterId?: number | string;
};

export function useSelectedUserTerritoryId(): string | undefined {
  const sessionFilters = useContext(ChatSessionFiltersContext);
  const { data } = useAgentResources();

  return useMemo(() => {
    const territoryFilter = data.filters.find((filter) => filter.type === FilterTypeEnum.UserTerritory);

    if (!territoryFilter) {
      return undefined;
    }

    const territoryCustomFilter = (sessionFilters.custom ?? []).find((customFilter) => {
      if (customFilter.type !== ChatCustomFilter.AgentFilter) {
        return false;
      }

      const firstValue = customFilter.value[0] as AgentFilterValueWithMetadata | undefined;
      if (!firstValue?.filterId) {
        return false;
      }

      return Number(firstValue.filterId) === territoryFilter.id;
    });

    if (!territoryCustomFilter || territoryCustomFilter.type !== ChatCustomFilter.AgentFilter) {
      return undefined;
    }

    const firstValue = territoryCustomFilter.value[0];
    return firstValue?.id || undefined;
  }, [data.filters, sessionFilters.custom]);
}
